import React, { Component, Fragment } from 'react';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image, Font, BlobProvider, PDFDownloadLink } from '@react-pdf/renderer';
import utils from "../../../ProducaoEP/utils/utils";
import TabelaGratuidade from '../TabelaGratuidade';
import TabelaConsolidadaPorUnidade from '../TabelaConsolidadaPorUnidade';
import utilsExport from '../../../../utils/utilsExport';
import calculo from './calculo';

export default class ContentPDFDR extends Component {

    constructor(props) {
        super(props);

        this.state = {
            styles: StyleSheet.create(utilsExport.styles)
        };

    }

    async componentDidMount() {

        Font.register({
            family: 'Oswald',
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
        });

    }

    TabelaRealizados = (styles, realizado, unidade, total) => {
        let modalidades = realizado.modalidades;
        let mesReferencia = <Text style={styles.textCaptalize}>{ `( ${utilsExport.exibeMes(this.props)} )` }</Text>
        let mesReferenciaRealizado = <Text style={styles.textCaptalize}>{ `( ${utilsExport.exibeMes(this.props)} )` }</Text>
        return (
            <Fragment>
                <View style={styles.table}>

                    <View style={styles.tableRowUnidadeHeader}>
                        <Text style={styles.unidadeHeader}>{utilsExport.retiraCodigoUnidade(unidade)}</Text>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableColHeaderMetaRealizadoModalidades}>
                            <Text style={styles.tableCellMetaRealizadoHeader}></Text>
                        </View>
                        <View style={styles.tableColCabecalho2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Matrículas</Text>
                        </View>
                        <View style={styles.tableColCabecalho2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Horas</Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableColHeaderMetaRealizadoModalidades}>
                            <Text style={styles.tableCellMetaRealizadoHeader}></Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader1}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Original {mesReferencia} </Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Retificada {mesReferenciaRealizado}</Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader1}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Original {mesReferencia}</Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Retificada {mesReferenciaRealizado}</Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableColHeaderModalidades}>
                            <Text style={styles.tableCellHeader}>Modalidades</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Não-Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Pagas</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Total</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Não-Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Pagas</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Total</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>%</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Não-Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Pagas</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Total</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Não-Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Pagas</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Total</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>%</Text>
                        </View>
                    </View>
                    {
                        Object.keys(modalidades).map(modalidade => {
                            let meta = modalidades[modalidade]['meta'];
                            let realizado = modalidades[modalidade]['retificada'];
                            let totalMetaMatriculas = meta["matricula_pago"] + meta["matricula_nao_regimental"] + meta["matricula_regimental"]
                            let totalRealizadoMatriculas = realizado["matricula_pago"] + realizado["matricula_nao_regimental"] + realizado["matricula_regimental"]
                            let totalMetaHoras = meta["hora_pago"] + meta["hora_nao_regimental"] + meta["hora_regimental"]
                            let totalRealizadoHoras = realizado["hora_pago"] + realizado["hora_nao_regimental"] + realizado["hora_regimental"]

                            // verifica modalidades com valores zerados para omitir a visualização
                            let valoresZerados = totalMetaMatriculas + totalRealizadoMatriculas + totalMetaHoras + totalRealizadoHoras
                            if(valoresZerados === 0) return;
                            
                            return (
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColModalidades}>
                                        <Text style={styles.tableCellModalidades}>{modalidade}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalMetaMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataPercentualExportOriginalRetificada(totalMetaMatriculas, totalRealizadoMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalMetaHoras)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoHoras)}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataPercentualExportOriginalRetificada(totalMetaHoras, totalRealizadoHoras)}</Text>
                                    </View>
                                </View>
                            )
                        })
                    }
                    {this.exibeTotais(styles, total)}
                    
                </View>
                {/* <View>
                    <Text style={styles.tableCell}>* Observações: {utilsExport.exibeObservacao(this.props)}</Text>
                </View> */}
            </Fragment>
            
        )
    }

    TabelaRealizadosFaculdade = (styles, realizado, unidade, total, totalDR) => {
        let modalidades = realizado.modalidades;
        return (
            <Fragment>
                <View>

                    {/* <View style={styles.tableRowUnidadeHeader}>
                        <Text style={styles.unidadeHeaderFaculdade}>{'Faculdade'}</Text>
                    </View> */}

                    {
                        Object.keys(modalidades).map(modalidade => {
                            let meta = modalidades[modalidade]['meta'];
                            let realizado = modalidades[modalidade]['retificada'];
                            let totalMetaMatriculas = meta["matricula_pago"] + meta["matricula_nao_regimental"] + meta["matricula_regimental"]
                            let totalRealizadoMatriculas = realizado["matricula_pago"] + realizado["matricula_nao_regimental"] + realizado["matricula_regimental"]
                            let totalMetaHoras = meta["hora_pago"] + meta["hora_nao_regimental"] + meta["hora_regimental"]
                            let totalRealizadoHoras = realizado["hora_pago"] + realizado["hora_nao_regimental"] + realizado["hora_regimental"]

                            // verifica modalidades com valores zerados para omitir a visualização
                            let valoresZerados = totalMetaMatriculas + totalRealizadoMatriculas + totalMetaHoras + totalRealizadoHoras
                            if(valoresZerados === 0) return;
                            
                            return (
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColModalidades}>
                                        <Text style={styles.tableCellModalidades}>{modalidade}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalMetaMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataPercentualExportOriginalRetificada(totalMetaMatriculas, totalRealizadoMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalMetaHoras)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoHoras)}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataPercentualExportOriginalRetificada(totalMetaHoras, totalRealizadoHoras)}</Text>
                                    </View>
                                </View>
                            )
                        })
                    }
                    {this.exibeTotais(styles, total)}
                    {this.exibeTotais(styles, totalDR)}

                </View>
                <View>
                    <Text style={styles.tableCell}>* Observações: {utilsExport.exibeObservacaoOriginalRetificada(this.props)}</Text>
                </View>
            </Fragment>
            
        )
    }

    exibeTotais = (styles, totais) => {
        let { meta, retificada: realizado } = totais;
        let totalMetaMatriculas = meta["matricula_pago"] + meta["matricula_nao_regimental"] + meta["matricula_regimental"]
        let totalRealizadoMatriculas = realizado["matricula_pago"] + realizado["matricula_nao_regimental"] + realizado["matricula_regimental"]
        let totalMetaHoras = meta["hora_pago"] + meta["hora_nao_regimental"] + meta["hora_regimental"]
        let totalRealizadoHoras = realizado["hora_pago"] + realizado["hora_nao_regimental"] + realizado["hora_regimental"]
        let viewTotais =  (
            <View style={styles.tableRowTotais}>
                <View style={styles.tableColModalidades}>
                    <Text style={styles.tableCellModalidades}>{}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_nao_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_pago'])}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalMetaMatriculas)}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_nao_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_pago'])}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoMatriculas)}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataPercentualExportOriginalRetificada(totalMetaMatriculas, totalRealizadoMatriculas)}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_nao_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_pago'])}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalMetaHoras)}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_nao_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_pago'])}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoHoras)}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataPercentualExportOriginalRetificada(totalMetaHoras, totalRealizadoHoras)}</Text>
                </View>
            </View>
        )
        return viewTotais
    }

    verificaFaculdade = (realizado) => calculo.verificaFaculdade(realizado)

    calculaTotal = (realizados) => calculo.calculaTotal(realizados)

    render() {
        let { styles } = this.state;
        let { realizado, unidade, total, metaOriginalERetificada } = this.props
        let { ep, faculdade } = this.verificaFaculdade(realizado)
        let totalEP = this.calculaTotal(ep);
        let totalFaculdade = this.calculaTotal(faculdade);
        styles = JSON.parse(JSON.stringify(styles))
        styles.table.marginTop = 0
        return (
            <Fragment>
                <Page orientation={"landscape"} >
                    {this.TabelaRealizados(styles, ep, unidade, totalEP)}
                    {this.TabelaRealizadosFaculdade(styles, faculdade, unidade, totalFaculdade, total['DR'])}
                </Page>
                {/* <Page orientation={"landscape"} >
                    {this.TabelaRealizados(styles, ep, unidade, totalEP)}
                </Page> */}
            </Fragment>
        );
    }
}
